import React from "react";
import { Col, Row } from "react-bootstrap";

// --- Kept Icons ---
import C from "../../Assets/TechIcons/C++.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";

// --- Added Icons (Commented out until you add the files) ---
import Flutter from "../../Assets/TechIcons/flutter.svg";
import Tauri from "../../Assets/TechIcons/TAURI.svg";
import HTML from "../../Assets/TechIcons/HTML.svg";
import CSS from "../../Assets/TechIcons/CSS.svg";
import bootstrap from "../../Assets/TechIcons/BOOTSTRAP.svg";
import PHP from "../../Assets/TechIcons/PHP.svg";
import MySQL from "../../Assets/TechIcons/MYSQL.svg";
import NoSQL from "../../Assets/TechIcons/NOSQL.svg";
import Pocketbase from "../../Assets/TechIcons/POCKETBASE.svg";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* --- Kept Items --- */}
      <Col xs={4} md={2} className="tech-icons">
        <img src={C} alt="C++" className="tech-icon-img" />
        <div className="tech-icons-text">C++</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="javascript" className="tech-icon-img" />
        <div className="tech-icons-text">Javascript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="typescript" className="tech-icon-img" />
        <div className="tech-icons-text">Typescript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="react" className="tech-icon-img" />
        <div className="tech-icons-text">React.Js</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="git" className="tech-icon-img" />
        <div className="tech-icons-text">Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="tailwind" className="tech-icon-img" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={bootstrap} alt="bootstrap" className="tech-icon-img" />
        <div className="tech-icons-text">Boot Strap</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={MUI} alt="mui" className="tech-icon-img" />
        <div className="tech-icons-text">Material UI</div>
      </Col>

      {/* --- Added Items --- */}
      
       <Col xs={4} md={2} className="tech-icons">
        <img src={HTML} alt="HTML" className="tech-icon-img" />
        <div className="tech-icons-text">HTML</div>
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <img src={Flutter} alt="Flutter" className="tech-icon-img" />
        <div className="tech-icons-text">Flutter</div>
      </Col>

      {/* --- Commented Out Items --- */}
      
      <Col xs={4} md={2} className="tech-icons">
        <img src={CSS} alt="CSS" className="tech-icon-img" />
        <div className="tech-icons-text">CSS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={PHP} alt="PHP" className="tech-icon-img" />
        <div className="tech-icons-text">PHP</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={MySQL} alt="MySQL" className="tech-icon-img" />
        <div className="tech-icons-text">MySQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={NoSQL} alt="NoSQL" className="tech-icon-img" />
        <div className="tech-icons-text">NoSQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Tauri} alt="Tauri" className="tech-icon-img" />
        <div className="tech-icons-text">Tauri</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Pocketbase} alt="Pocketbase" className="tech-icon-img" />
        <div className="tech-icons-text">Pocketbase</div>
      </Col>
       
    </Row>
  );
}

export default Techstack;